export enum CartReactQueryKeys {
    MyCart = 'my-cart',
    POPList = 'POP_LIST',
}

export enum OrderPages {
    Cart = 'CART',
    Shipping = 'SHIPPING',
    Payment = 'PAYMENT',
}
